export default __webpack_public_path__ + "static/media/ehaLogo.11123fbe.png";